
import React from 'react';

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16'
};

const colors = {
  blue: 'border-blue-600',
  red: 'border-red-600',
  green: 'border-green-600',
  purple: 'border-purple-600',
  indigo: 'border-indigo-600'
};

const LoadingSpinner = ({ size = 'md', color = 'blue', className = '' }) => (
  <div className={`${className} flex items-center justify-center`}>
    <div
      className={`
        ${sizes[size] || sizes.md}
        ${colors[color] || colors.blue}
        border-2
        border-t-transparent
        rounded-full
        animate-spin
      `}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

export default LoadingSpinner; 